import React, { useState, useEffect } from 'react';
import InputText from '../input/InputText';

const FiltriTestataOrdine = ({ onFilterChange, onResetFilters, initialFilters }) => {
    const [filters, setFilters] = useState(initialFilters || {
        IDOrdine: '',
        DataInizio: '',
        DataFine: '',
        Nome: '',
        Cognome: ''
    });

    useEffect(() => {
        if (initialFilters) {
            setFilters(initialFilters);
        }
    }, [initialFilters]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters(prevFilters => ({
            ...prevFilters,
            [name]: value
        }));
    };

    const handleApplyFilters = () => {
        onFilterChange && onFilterChange(filters);
    };

    const handleResetFilters = () => {
        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);

        const formatDate = (date) => date.toISOString().split('T')[0];

        const resetFilters = {
            IDOrdine: '',
            Nome: '',
            Cognome: '',
            DataInizio: formatDate(thirtyDaysAgo),
            DataFine: formatDate(today)
        };

        setFilters(resetFilters);
        onFilterChange && onFilterChange(resetFilters);
        onResetFilters && onResetFilters();
    };

    return (
        <div className="card">
            <div className="card-header">
                <h6 className="hstack gap-2 mb-0">Filtri ricerca</h6>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            id="Nome"
                            name="Nome"
                            label="Nome"
                            value={filters.Nome}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-3">
                        <InputText
                            className="form-control"
                            id="Cognome"
                            name="Cognome"
                            label="Cognome"
                            value={filters.Cognome}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-2">
                        <InputText
                            className="form-control"
                            id="IDOrdine"
                            name="IDOrdine"
                            label="Num. Ordine"
                            value={filters.IDOrdine}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-4">
                        <div className="row">
                            <div className="col-6">
                                <InputText
                                    className="form-control"
                                    id="DataInizio"
                                    name="DataInizio"
                                    label="Dal"
                                    type="date"
                                    value={filters.DataInizio}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-6">
                                <InputText
                                    className="form-control"
                                    id="DataFine"
                                    name="DataFine"
                                    label="Al"
                                    type="date"
                                    value={filters.DataFine}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-footer d-sm-flex justify-content-sm-between align-items-sm-center py-sm-2">
                <div className="btn-group w-100 w-sm-auto"></div>
                <div className="hstack gap-2 mt-3 mt-sm-0">
                    <button type="button" className="btn btn-light w-100 w-sm-auto" onClick={handleResetFilters}>
                        <i className="ph-x me-2"></i>Azzera filtri
                    </button>
                    <button type="button" className="btn btn-indigo w-100 w-sm-auto" onClick={handleApplyFilters}>
                        <i className="ph-check me-2"></i>Filtra
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FiltriTestataOrdine;
